<style scoped lang="less">
.traffic-container {
  width: 100%;
  height: 100%;
  .detail-main {
    position: relative;
    #detail_map {
      width: 100%;
      height: 100vh;
    }
    .detail-traffic {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 99;
      background: #fff;
      width: 100%;
      .traffic-count-box {
        margin-top: 34px;
        padding: 0 48px;
        margin-bottom: 20px;
        .traffic-count-show {
          .traffic-count {
            margin-top: 12px;
            width: 70px;
            height: 54px;
            line-height: 54px;
            text-align: center;
          }
        }
      }
    }
    .subway-info-box {
      position: fixed;
      left: 16px;
      bottom: 18px;
      background: #fff;
      box-shadow: 0px 4px 20px 0px rgba(136, 136, 136, 0.5);
      border-radius: 6px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 718px;
      height: 88px;
      font-size: 26px;
      .subway-info {
        display: flex;
        justify-content: center;
        align-items: center;
        .subway-title {
          color: #232c37;
        }
        .subway-count {
          color: rgba(137, 147, 159, 1);
          margin-left: 10px;
        }
      }
    }
    .distance-screen{
      position: fixed;
      left: 16px;
      bottom: 18px;
      background: #fff;
      box-shadow: 0px 4px 20px 0px rgba(136, 136, 136, 0.5);
      border-radius: 6px;
      width: 718px;
      height: 148px;
      .slider{
        margin-top: 50px;
        margin-left: 70px;
        margin-right: 70px;
      }
      .kedu{
        ul{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 30px 40px;
          li{
            font-size:26px;
            color:rgba(65,105,225,1);
          }
        }
      }
    }
  }
}
.common-box-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .common-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .common-title {
      height: 36px;
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(137, 147, 159, 1);
      line-height: 36px;
      margin-bottom: 10px;
    }
    .common-info {
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      //   color: rgba(35, 44, 55, 1);
      line-height: 44px;
    }
  }
}
.selected {
  color: #4169e1;
  border-bottom: 2px solid #4169e1;
}
</style>
<template>
  <div class="traffic-container">
    <div class="detail-main">
      <div class="detail-traffic main-wrapper">
        <div class="traffic-count-box common-box-wrapper">
          <div
            class="traffic-count-show common-box"
            v-for="(item,index) in trafficList"
            :key="index"
            @click="selectTraffic(item,index)"
          >
            <div class="traffic-name common-title">{{item.name}}</div>
            <div
              class="traffic-count common-info"
              :style="index==currentIndex?'color:#4169e1;border-bottom: 1px solid #4169e1;':''"              
            >{{item.value}}</div>
          </div>
        </div>
      </div>
      <div id="detail_map"></div>
      <div class="subway-info-box" v-if="currentIndex==0">
        <div class="subway-info">
          <div class="subway-title">换乘站</div>
          <div class="subway-count">{{trafficInfo.changeCount?trafficInfo.changeCount:0}}个</div>
        </div>
        <div class="subway-info">
          <div class="subway-title">始发站</div>
          <div class="subway-count">{{trafficInfo.startCount?trafficInfo.startCount:0}}个</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var map;
import { Toast,Slider } from "vant";
let timestampStart,timestampEnd;
export default {
  name: "traffic",
  components: {
    'van-slider':Slider
  },
  data() {
    return {
      currentIndex: 0,
      trafficList: [],
      latitude: 40.072029,
      longitude: 116.360235,
      polyline: 0,
      markers: [],
      scale: 14,
      polygons: [],
      subName: "",
      name: "",
      trafficInfo: {},
      sliderValue:0,
      cityId:30
    };
  },
  created() {
    let options = this.$route.query;
    timestampStart = (new Date()).getTime();
    this.addBuried({
      source:'1',
      eventType: '曝光事件',
      eventContent: '画圈交通配套'
    });
    this.latitude = options.latitude;
    this.longitude = options.longitude;
    this.polyline = options.polyline;
    this.name = options.name;
    this.cityId = options.cityId;
    this.currentIndex = options.currentIndex;
    this.getTrafficInfo();
    this.getTrafficDetail(options.name);
  },
  mounted() {
    map = new BMap.Map("detail_map");
    var point = new BMap.Point(this.longitude, this.latitude);
    map.centerAndZoom(point, 15);
    this.getThisPolyline();
  },
  methods: {
    //交通配套选择
    selectTraffic(item, index) {
      this.currentIndex = index;
      this.subName = item.name;
      this.addBuried({
        source:'1',
        eventType: '点击事件',
        eventContent: item.name
      });
      this.getTrafficDetail(item.name);
    },
    //获取交通汇总信息
    async getTrafficInfo() {
      await this.$axios
        .post("api/xz/draw/traffic/sum/", {
          polyline: this.polyline,
          cityId:this.cityId
        })
        .then(res => {
          if (res.success) {
            let list = res.result;
            this.trafficList = list;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取交通配套详情信息
    async getTrafficDetail(name) {
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner"
      });
      await this.$axios
        .post("api/xz/draw/traffic/info/", {
          polyline: this.polyline,
          cityId:this.cityId,
          name: name
        })
        .then(res => {
          if (res.success) {
            let labelArr = []
            map.clearOverlays();        
            this.trafficInfo = res.result;
            if (res && res.result && res.result.list) {
              let trafficDetailList = res.result.list;
              let len = trafficDetailList.length;
              for (let i = 0; i < len; i++) {
                var marker = new BMap.Marker(
                  new BMap.Point(
                    trafficDetailList[i].longitude,
                    trafficDetailList[i].latitude
                  )
                );
                map.addOverlay(marker);
                addClickHandler(trafficDetailList[i].name,marker);
              }
              function addClickHandler(content,marker){
                marker.addEventListener("click",function(e){
                    let label;
                    label = new BMap.Label(content,{offset:new BMap.Size(20,-10)});
                    label.setStyle({
                      color : "#000",
                      fontSize : "12px",
                      height : "20px",
                      lineHeight : "20px",
                      fontFamily:"微软雅黑",
                      borderColor:"#000"
                    });
                    marker.setLabel(label);
                    labelArr.push(marker.getLabel())
                    for (let i = 0; i < labelArr.length; i++) {
                      if (labelArr[i].content != content) {
                        map.removeOverlay(labelArr[i]);
                      }                      
                    }
                  }
                );
              }
            }
            Toast.clear();
          }
        })
        .catch(err => {});
    },
    //获取当前商圈描边信息
    async getThisPolyline() {
      let coordinateList = JSON.parse(localStorage.getItem('drawList')); 
      let len = coordinateList.length;
      let arr = [];
      for (let i = 0; i < len; i++) {
        arr.push(
          new BMap.Point(
            coordinateList[i].lng,
            coordinateList[i].lat
          )
        );
      }
      var polygon = new BMap.Polygon(arr, {
        strokeColor: "#4169E1",
        strokeStyle: "dashed",
        fillColor: "#4169E1",
        strokeWeight: 3,
        strokeOpacity: 1,
        fillOpacity: 0.1
      });
      polygon.disableMassClear();
      map.addOverlay(polygon);
    }
  },
  destroyed() {
    timestampEnd = (new Date()).getTime();
    let residenceTime = timestampEnd-timestampStart;
    this.addBuried({
      source:'1',
      eventType: '页面停留时长',
      eventContent: '画圈交通配套停留时长'+residenceTime/1000+'s'
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/draw_traffic_matching/index.vue